import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'present-users-live-dashboard-page',
    templateUrl: './present-users-live-dashboard-page.component.html',
    styleUrls: ['./present-users-live-dashboard-page.component.scss'],
    standalone: false
})
export class PresentUsersLiveDashboardPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
